<template>
  <div class="MainArticleList">
    <swiper :options="swiperOption" class="main-list" v-if="articles.length">
      <swiper-slide v-for="(item, index) in articles.length" :key="index">
        <div class="main-item" @click="clickToViewDetail(index)">
          <div class="main-item-box" :style="getItemImage(index)">
            <div class="item-img-shadow" v-if="getItemImage(index)"></div>
            <div class="item-content" :class="{ 'black-content': getItemImage(index) === false }">
              <div
                class="item-title"
                :class="{ 'position-bottom': hasAtNoAb(index), 'position-middle': noAtNoAb(index) }"
              >
                {{ getItemTitle(index) }}
              </div>
              <div class="item-abstract" v-if="getItemAbstract(index)">{{ getItemAbstract(index) }}</div>
            </div>
            <div class="item-learn" :class="{ 'black-learn': getItemImage(index) === false }" v-if="!hasAtNoAb(index)">
              Learn More
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import processImage from '@/common/processImage'

export default {
  name: 'MainArticleList',
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      articles: [],
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 48,
        loop: true,
        autoplay: {
          delay: 10000,
          disableOnInteraction: false,
        },
      },
      screenWidth: document.body.clientWidth,
    }
  },
  created() {
    this.setSwiperWidth()
    this.getArticles()
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    setSwiperWidth() {
      let perView = Math.floor((window.innerWidth - 172) / 270)
      let spaceBetween = Math.floor((window.innerWidth - 172 - perView * 270) / perView)
      this.swiperOption.slidesPerView = perView
      this.swiperOption.spaceBetween = spaceBetween
    },
    getArticles() {
      this.$axios({
        url: '/api/v1/client/estate/content/getContentListByCategoryUniqueId/Explore-San-Francisco-Neighborhoods',
        method: 'get',
      })
        .then(res => {
          if (res.ok) {
            this.articles = res.doc
          }
        })
        .catch(() => {
          console.error('error on GET:getArticles')
        })
    },
    getItemImage(index) {
      let item = this.articles[index]
      if (item.attachment && item.attachment[0] && item.attachment[0].url) {
        let url = processImage.processImage(item.attachment[0].url, { resize: 'mid' })
        return "background-image: url('" + url + "')"
      }
      return false
    },
    getItemTitle(index) {
      let item = this.articles[index]
      if (item.title && item.title.length) {
        return item.title
      }
      return false
    },
    getItemAbstract(index) {
      let item = this.articles[index]
      if (item.abstract && item.abstract.length) {
        return item.abstract
      }
      return false
    },
    //存在attachment不存在abstract，title置于底部，不展示learn more
    hasAtNoAb(index) {
      let item = this.articles[index]
      return (
        (item.attachment &&
          item.attachment[0] &&
          item.attachment[0].url &&
          (!item.abstract || item.abstract.length === 0)) === true
      )
    },
    //不存在attachment不存在abstract，title置于中间
    noAtNoAb(index) {
      let item = this.articles[index]
      return (
        (!item.attachment || !item.attachment[0] || !item.attachment[0].url || item.attachment[0].url.length === 0) &&
        (!item.abstract || item.abstract.length === 0) === true
      )
    },
    clickToViewDetail(index) {
      let item = this.articles[index]
      this.$emit('viewDetail', item)
    },
  },
  watch: {
    screenWidth() {
      document.getElementById('app').scrollIntoView()
      location.reload()
    },
  },
}
</script>

<style scoped lang="less">
@import url('../assets/less/var.less');

.MainArticleList {
  padding: 27px 0;
  width: 100%;

  .main-list {
    margin: 0 auto;
    height: 330px;
    width: calc(100% - 172px);

    .main-item {
      width: 270px;
      height: 325px;
      box-sizing: border-box;
      background: rgba(249, 249, 249, 1);
      border: 2px solid rgba(51, 51, 51, 1);
      cursor: pointer;

      .main-item-box {
        position: relative;
        margin: 5px;
        width: 254px;
        height: 311px;
        background: no-repeat center center;
        background-size: cover;

        .item-img-shadow {
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
        }

        .item-content {
          position: absolute;
          top: 17px;
          left: 24px;
          height: 210px;
          color: rgba(249, 249, 249, 1);

          .item-title {
            margin-bottom: 28px;
            width: 206px;
            font-size: 18px;
            font-weight: 600;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            line-height: 24px;
          }

          .item-abstract {
            width: 206px;
            font-size: 12px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 4;
            overflow: hidden;
            line-height: 20px;
          }

          .position-middle {
            margin-top: 60px;
          }

          .position-bottom {
            position: absolute;
            bottom: -90px;
          }
        }

        .item-learn {
          position: absolute;
          left: 24px;
          bottom: 20px;
          width: 166px;
          height: 37px;
          background: rgba(51, 51, 51, 1);
          border: 2px solid rgba(249, 249, 249, 1);
          text-align: center;
          color: rgba(249, 249, 249, 1);
          font-size: 14px;
          font-weight: 600;
          line-height: 37px;
          cursor: pointer;
        }

        .black-content {
          color: #333;
        }

        .black-learn {
          width: 166px;
          height: 37px;
          background: rgba(249, 249, 249, 1);
          border: 2px solid rgba(51, 51, 51, 1);
          color: rgba(51, 51, 51, 1);
        }
      }
    }
  }
}
</style>
